<div class="reporter-login"
  reporterLoginImage>
</div>


<reporter-modal [show]="!hideView"
  [modalClasses]="loginPageVersion === 'CUSTOM_UI_CONFIG' ? 'login-modal custom-ui-config-login-modal' : 'login-modal'"
  [displayCloseBtn]="false"
  [noFooter]="true">
  @if (showMfaNotice) {
    <div role="modal-notice" class="alert alert-danger text-center mfa-pre-live-notice">
      On <strong class="text-nowrap">February 1, 2027</strong>, users will be required to login to the <strong class="text-nowrap">GBGO® firstconnect</strong>
      platform using Multi-Factor Authentication (MFA).
    </div>
  }
  <div role="modal-body">
    @if (loginPageVersion === 'CUSTOM_UI_CONFIG') {
      <reporter-custom-ui-config-login
        [uiConfig]="uiConfig"
        [isAuthenticated]="isAuthenticated"
        [sso401]="sso401"
        [currentUser]="currentUser"
        [gbru]="gbru"
        (login)="oidcLogin()"
        (submit)="onSubmit()"
        [failed]="failed"
        [mfaNoticeEnabled]="mfaNoticeEnabled"
        [customerMessageError]="customerMessageError"
        [loginForm]="loginForm">
      </reporter-custom-ui-config-login>
    }
    @if (loginPageVersion === 'DEFAULT') {
      <div [hidden]="showForgotPassword" class="container text-center">
        @if (!gbru && !sso401 && (mfaNoticeEnabled || !useLegacy)) {
          <h3>Welcome to GBGO® firstconnect</h3>
          <div>
            For your convenience, please bookmark this page.
          </div>
        } @else {
          <h3>Welcome to GBGO® firstconnect</h3>
        }
        @if (gbru && !sso401 ) {
          <div>
            Your session has expired, please login again to continue using the application.
          </div>
        }
        @if (useLegacy && !sso401 && !mfaNoticeEnabled) {
          <reporter-mfa-onboarding></reporter-mfa-onboarding>
        }
        @if (sso401) {
          <div>
            <p class="font-weight-bold">
              <span>A problem occurred verifying the user account. Please contact
                <a href="mailto:support@mvsc.com">support&#64;mvsc.com</a> for
              assistance.</span>
            </p>
          </div>
        }
      </div>
      <div [hidden]="useLegacy || showForgotPassword"
        class="container text-center"
        role="modal-body">
        <button class="btn btn-action sso mt-4"
          (click)="oidcLogin()">LOGIN USING SINGLE SIGN ON
        </button>
        @if (loginType !== 'SSO_ONLY') {
          <div
            class="alternative legacy mt-3">
            <button class="btn btn-link px-0"
              (click)="useLegacy = true">Click here
            </button>
            if you do not have Single Sign On
          </div>
        }
      </div>
      <div [hidden]="!useLegacy || showForgotPassword"
        class="container text-center mt-3"
        role="modal-body">
        @if (loginForm !== undefined) {
          <form
            [formGroup]="loginForm"
            (ngSubmit)="onSubmit()"
            autocomplete="off">
            <div class="form-group">
              <label class="required">Username</label>
              <input type="text"
                class="form-control required"
                formControlName="userId"
                placeholder="john.smith">
            </div>
            <div class="form-group mb-1">
              <label class="required">Password</label>
              <input type="password"
                class="form-control required"
                formControlName="password"
                placeholder="Password"
                autocomplete="new-password">
            </div>
            @if (failed) {
              <div
                class="text-danger my-3">
                {{customerMessageError !== '' ? customerMessageError : 'Invalid credentials.'}}
              </div>
            }
            <div>
              <button type="submit"
                class="btn btn-action px-5 mt-4"
                [disabled]="loginForm.invalid">Login
              </button>
            </div>
          </form>
        }
        @if (failed) {
          <div>
            <button class="btn btn-link px-0"
              (click)="showForgotPassword = true">
              Forgot Password
            </button>
          </div>
        }
        @if (loginType !== 'LEGACY_ONLY') {
          <div
            class="alternative sso mt-3">
            <button class="btn btn-link px-0"
              (click)="useLegacy = false">
              Click here
            </button>
            if you want to use Single Sign On
          </div>
        }
      </div>
      <reporter-forgot-password [hidden]="!showForgotPassword" (onBackToLogin)="showForgotPassword = false">
      </reporter-forgot-password>
    }
  </div>
</reporter-modal>
